<template>
<div>
  <b-badge :variant=variant v-b-popover.hover=hover>
    {{status | titleize}}
    <span v-if='fishbowlOrder.backordered'> / Backordered</span>
  </b-badge>
  <b-alert :show='!!warning' variant=warning>
    {{warning}}
  </b-alert>
</div>
</template>

<script>
import moment from 'moment'

export default {
  props: {
    fishbowlOrder: { type: Object, required: true },
    toImport: { type: Boolean, default: false },
    toIssue: { type: Boolean, default: false },
  },
  computed: {
    status() {
      if (this.toIssue) {
        return 'to_be_issued'
      } else if (this.toImport) {
        return 'to_be_imported'
      } else if (!!this.fishbowlOrder && !!this.fishbowlOrder.status) {
        return this.fishbowlOrder.status
      } else {
        return 'not_in_fishbowl'
      }
    },
    hover() {
      let order = this.fishbowlOrder;
      let itemStatus = typeof order.items === 'undefined' ? [] : this.uniqueStatus(order.items.map(x => x.soItemStatus))
      let pickStatus = typeof order.picks === 'undefined' ? [] : this.uniqueStatus(order.picks.map(x => x.status))
      let shipStatus = typeof order.shippings === 'undefined' ? [] : this.uniqueStatus(order.shippings.map(x => x.status))
      return `
        SO: ${this.fishbowlOrder.soStatusName}
        Items: ${this.stringify(itemStatus)}
        Pick: ${this.stringify(pickStatus)}
        Ship: ${this.stringify(shipStatus)}
      `
    },
    variant() {
      let variant = 'secondary'
      switch (this.status) {
        case 'to_be_imported':
        case 'to_be_issued':
          variant = 'info'
          break
        case 'issued':
        case 'partially_shipping_today':
        case 'shipping_today':
        case 'fulfilled_and_shipped':
          variant = 'success'
          break
        case 'partially_packing':
        case 'partially_packed':
        case 'picking':
        case 'packing':
        case 'picking_and_packing':
        case 'picking_and_packed':
          variant = 'primary'
          break
        case 'picking_backordered':
        case 'packing_backordered':
        case 'partially_backordered':
          variant = 'dark'
          break
        case 'closed_short':
          variant = 'warning'
          break
        case 'voided':
        case 'expired':
        case 'canceled':
          variant = 'danger'
          break
        default:
          variant = 'secondary'
          break
      }
      if (this.fishbowlOrder.backordered) variant = 'dark'
      return variant
    },
    warning() {
      let warning = undefined
      if (this.fishbowlOrder.status === 'picking_and_packing') {
        warning = 'May cause issues when packing second order!'
      }
      else if (this.fishbowlOrder.status === 'picking_and_packed') {
        warning = 'Should find both shipments & combine'
      }
      else if (this.fishbowlOrder.status === 'picking') {
        let lastPick = this.maxDate(this.fishbowlOrder.picks, 'startedAt')
        if (Date.now() - (24*60*60) < lastPick) {
          warning = 'Picking started more than a day ago!'
        } else if (Date.now() - (5*60) < lastPick) {
          warning = 'Picking started more than 5 minutes ago!'
        }
      }
      else if (this.fishbowlOrder.status === 'partially_packing' && Date.now() - (24*60*60) < this.maxDate(this.fishbowlOrder.shippings, 'createdAt')) {
        warning = 'Shipment created more than a day ago!'
      }
      return warning
    }
  },
  methods: {
    uniqueStatus(arr) {
      arr = arr.filter(x => !!x.id)
      return Array.from(new Set(arr.map(x => x.id))).map(id => {
        return arr.find(x => x.id === id)
      })
    },
    maxDate(arr, key) {
      return moment(arr.reduce((max, current) => max[key] > current[key] ? max : current))
    },
    stringify(arr) {
      if (arr.length === 0) {
        return 'N/A'
      } else if (arr.length === 1) {
        return arr[0].name
      } else {
        return `[${arr.map(x => `${x.name}`).join(', ')}]`
      }
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/sales-order/view-order-2/FishbowlStatus.vue